define([
	"dojo/_base/declare",
	"dojo/dom-class",
	"csi",
	"csi/_base/underscore",
	"../SizeChart",
	"./Number",
	"./ActualMixin"
], function(declare,domClass,csi,_,SizeChart,NumberRen,ActualMixin) {

	var RE_URL_NUMBER = /^C([0-9]*)_/;

	return declare([NumberRen, ActualMixin], {
		bBaseRenderer: true,
		highlightSetting: "sizeChartHighlightActualOutOfTolerance",

		toHtmlStatic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*ActionData*/actionData) {
			// summary: color red if out of tolerance - make sure to take tolerance format into account
			if (ctx.view.get(this.highlightSetting)) {
				var bOut = this._isOutOfTolerance(ctx, this._getValue(ctx, h), this._getTarget(ctx));

				// recompute out-of-tolerance based on formatted values as long as we aren't in fraction of inches
				var fmt = this._getFormat(ctx, h);
				if (fmt != "IN - Fraction") {
					// see if we are in a locale where periods render as commas.
					var formatTest = this.formatValue("0.1", "0.0"); // will either be 0.1 or 0,1
					
					var formattedValue = this.formatValue(this._applyFactor(ctx, this._getValue(ctx, h)), fmt);
					var formattedTarget = this.formatValue(this._applyFactor(ctx, this._getTarget(ctx)), fmt);
					
					if (formatTest == "0,1") { // comma and period swapped
						formattedValue  = formattedValue.replace(",", "."); // switch it back
						formattedTarget = formattedTarget.replace(",", "."); // switch it back
					}
					
					bOut = this._isOutOfTolerance(ctx, formattedValue, formattedTarget);
				}

				domClass.toggle(refNode, "tableSizeChartActualOut", bOut);
			}

			return this.inherited(arguments);
		},

		_getReviewDimension: function(/*Context*/ctx) {
			// summary: return review dimension for context
			return ctx.getNodeOfType("SizeChartReviewDimension");
		},

		_getTarget: function(/*Context*/ctx) {
			// summary: return target value for dimension
			return this._getReviewDimension(ctx).Target;
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return target value if editing default number
			var	value = this.inherited(arguments);

			// lookup actual using old technique
			var node = ctx.getNode();
			var attribute = node ? node[h.m_id] : null;
			if ((value == this.DEFAULT) && ctx.keyValue2 && attribute) {
				value = attribute[ctx.keyValue2] || this.DEFAULT;
			}

			// lookup value from the Original dimension if needed
			if (value === undefined && attribute) {
				value = attribute[ctx.keyOriginalValue];
			}

			// DE23537: for unlinked/special SizeChartDimension, new ApparelDimension is created on revise, evaluate, pass and fail, and hence the SampleDimensions.DimensionActuals doublemap key changes.
			// Logic here tries to lookup the key using SizeChartDimension.SysId which stay same through SizeChartRevisions.
			if ((value == this.DEFAULT) && ctx.keySuffix && attribute) {
				var	keys = _.keys(attribute || {});
				if (keys.length > 0) {
					keys = _.filter(keys, function(key) {
						// Check if key is ends with ctx.keySuffix
						return key != null && key.substr(key.length - ctx.keySuffix.length) == ctx.keySuffix;
					});

					// Find the key with URL of ApparelDimension of later revision - urls should be of form C123, except when imported;
					// in that case don't worry about sorting as this case is for special dimensions
					if (keys.length > 1) {
						keys = csi.sort(keys, function(key) {
							var res = RE_URL_NUMBER.exec(key);
							return res ? Number(res[1]) : 0;
						});
					}

					if (keys.length) {
						value = attribute[keys.last()];
					}
				}
			}

			return (ctx.dynamicNumber && (value == this.DEFAULT || value === undefined)) ? this._getTarget(ctx) : value;
		}
	});
});